
import { Component, Prop, Vue } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import AvailableDiscountsModal from '@/components/shared/AvailableDiscountsModal.vue';

const namespace: string = 'cart';

@Component<AvailableDiscountsBanner>({
	components: {
		AvailableDiscountsModal
	}
})
export default class AvailableDiscountsBanner extends Vue {
	@Prop({ type: Boolean, required: false, default: false }) private inCart!: boolean;
	@Getter('getMembershipDiscounts', { namespace }) private membershipDiscounts!: (PunchhPromo | MemberPromo)[];
	@Getter('getMemberInfo', { namespace }) private memberInfo!: CheckoutMemberInfo | null;

	private showModal: boolean = false;

	private get discountsSelected(): boolean {
		return !!this.memberInfo?.promosApplied.size;
	}

	private handleModalClose(haveDiscountsChanged?: boolean) {
		this.$emit('close', this.inCart && haveDiscountsChanged);
		this.showModal = false;
	}
}
